const REPORTS_FILES_LOCATION = process.env.REACT_APP_REPORTS_FILES_LOCATION;
export const getReportUrlById = id => `${REPORTS_FILES_LOCATION}${id}.json`;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;